var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Card", { attrs: { cardClass: "fullWidthCard makeHeightAuto" } }, [
    _c("div", { staticClass: "flex w-full flex-col p-4" }, [
      _c("div", { staticClass: "mb-4 flex flex-col flex-initial" }, [
        _c(
          "div",
          {},
          [
            _c(
              "RouterLink",
              { attrs: { to: _vm.navigateToContractorProfile } },
              [
                _c("ResourceAvatar", {
                  staticClass: "cursor-pointer text-primary-500",
                  attrs: {
                    image: _vm.contractorAvatar,
                    initial: _vm.contractorInitials,
                    available: _vm.contractorAvailable,
                    avatarClasses: "h-8 w-8",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "w-full" }, [
        _c(
          "div",
          {
            staticClass:
              "truncate flex flex-1 flex-col justify-flex-start flex-wrap",
          },
          [
            _c(
              "RouterLink",
              {
                staticClass: "hover:text-primary-500",
                attrs: { to: _vm.navigateToContractorProfile },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "blueLabelActive truncate font-Outfit text-lg font-medium mr-2",
                  },
                  [_vm._v(_vm._s(_vm.contractorName))]
                ),
              ]
            ),
            !_vm.newContractor
              ? _c("CardInfoChip", {
                  attrs: { message: "Company member", green: true },
                })
              : _vm._e(),
            _vm.newContractor
              ? _c("CardInfoChip", {
                  attrs: { message: "Not a Company member", red: true },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "flex flex-wrap w-full mt-1" }, [
          _c(
            "div",
            {
              staticClass:
                "defaultLabelContainer flex-col flex-grow hidden sm:flex",
            },
            [
              _vm.contractorLocation
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-5",
                    },
                    [
                      _c("LocationIconNew", {
                        staticClass: "pr-2 w-auto h-auto",
                      }),
                      _vm._v(_vm._s(_vm.contractorLocation) + " "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.profileConfirmed
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-1",
                    },
                    [
                      _c("ProfileIcon", { staticClass: "pr-2 w-auto h-auto" }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-primary-black font-400 text-sm pr-2",
                        },
                        [_vm._v("ProveraCare profile")]
                      ),
                      _vm._v(_vm._s(_vm.profileConfirmed) + " "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.contractorRates
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-1",
                    },
                    [
                      _c("DollarIcon", { staticClass: "pr-2 w-auto h-auto" }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-primary-black font-400 text-sm pr-2",
                        },
                        [_vm._v("Rate")]
                      ),
                      _vm._v(_vm._s(_vm.contractorRates) + " "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.requestedDate
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-flex-start items-center text-storm-gray text-sm font-medium",
                    },
                    [
                      _c("CalendarIcon", { staticClass: "pr-2 w-auto h-auto" }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-primary-black font-400 text-sm pr-2",
                        },
                        [_vm._v("Requested on")]
                      ),
                      _vm._v(_vm._s(_vm.requestedDate) + " "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._t("requestedBy"),
            ],
            2
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass:
          "flex flex-col w-full items-center bg-white border-t border-gray-200 adjustFlexWidth px-4",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "flex gap-1 w-full skills-footer items-center pt-4 mb-4",
          },
          [
            _vm._v(" Skills: "),
            _vm.contractorSkills.length > 0
              ? _c(
                  "div",
                  { staticClass: "flex flex-row gap-1 flex-wrap items-center" },
                  [
                    _vm._l(_vm.contractorSkills.slice(0, 3), function (skill) {
                      return _c(
                        "div",
                        { key: skill.id, staticClass: "skills-chip" },
                        [_vm._v(" " + _vm._s(skill?.name) + " ")]
                      )
                    }),
                    _vm.contractorSkills.length > 3
                      ? _c("div", [
                          _c("div", { staticClass: "skills-chip-plus" }, [
                            _vm._v(
                              " +" +
                                _vm._s(_vm.contractorSkills.length - 3) +
                                " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _c("div", [_vm._v("n/a")]),
          ]
        ),
        _c("div", { staticClass: "w-full flex items-center" }, [
          _vm.isAdmin
            ? _c(
                "div",
                { staticClass: "flex flex-col adjustFlexWidth" },
                [
                  _vm.showAddToCompany
                    ? _c("UiButton", {
                        staticClass: "mb-4",
                        attrs: {
                          variant: "black",
                          buttonText: "Add to company",
                          buttonClasses: "customButtonCard",
                          fullWidth: true,
                        },
                        on: { click: _vm.handleAddToCompanyConfirmation },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "flex flex-1 flex-col" },
                    [
                      _c("UiButton", {
                        staticClass: "mb-4",
                        attrs: {
                          variant: "black",
                          buttonText: "Approve",
                          buttonClasses: "customButtonCard",
                          fullWidth: true,
                        },
                        on: { click: _vm.handleApproveConfirmation },
                      }),
                      _c("UiButton", {
                        attrs: {
                          fullWidth: true,
                          variant: "outline",
                          buttonText: "Decline",
                          buttonClasses: "customButtonCard",
                        },
                        on: { click: _vm.handleDeclineConfirmation },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "flex flex-col adjustFlexWidth w-full" },
                [
                  _c("RemoveManagerContractorRequest", {
                    staticClass: "shadow-md mb-1",
                    attrs: {
                      buttonSize: "no",
                      buttonVariant: "black",
                      fullWidth: true,
                      contractorId: _vm.contractorId,
                      managerId: _vm.managerId,
                    },
                    on: {
                      requestRemoved: function ($event) {
                        return _vm.$emit("refetch")
                      },
                    },
                  }),
                ],
                1
              ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }